import React, { useState } from "react";
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { escalateSupportTicket } from "../../services/supportService";

/** Phase 2: escalate one tier up (L1 → L2 team lead → admin) with a required reason. */
export const ESCALATION_REASON_LABELS: Record<string, string> = {
    needs_approval: "Needs approval", angry_customer: "Angry customer", policy_exception: "Policy exception", legal_police: "Legal / police",
    low_csat: "Low rating", repeat_contact: "Third contact in 7 days",
};
const MANUAL = ["needs_approval", "angry_customer", "policy_exception", "legal_police"];

const EscalateDialog: React.FC<{ ticketId: string | number; open: boolean; onClose: () => void; onDone: (tier: string) => void; onConflict?: (message: string) => void }> = ({ ticketId, open, onClose, onDone, onConflict }) => {
    const [reason, setReason] = useState("");
    const [note, setNote] = useState("");
    const [error, setError] = useState<string | null>(null);

    const submit = async () => {
        try {
            const r = await escalateSupportTicket(ticketId, { reason, note: note.trim() || undefined });
            setReason(""); setNote(""); setError(null);
            onDone(r.data.escalationTier);
        } catch (e: any) {
            const message = e?.response?.data?.message || "Could not escalate the ticket";
            if (e?.response?.status === 409 && onConflict) { setError(null); onConflict(message); return; } // round 2 F4: someone else's ticket
            setError(message);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
            <DialogTitle>Escalate ticket</DialogTitle>
            <DialogContent>
                <FormControl fullWidth size="small" sx={{ mt: 1 }}>
                    <InputLabel id="esc-reason">Reason</InputLabel>
                    <Select labelId="esc-reason" label="Reason" value={reason} onChange={(e) => setReason(String(e.target.value))}>
                        {MANUAL.map((r) => <MenuItem key={r} value={r}>{ESCALATION_REASON_LABELS[r]}</MenuItem>)}
                    </Select>
                </FormControl>
                <TextField fullWidth size="small" sx={{ mt: 2 }} label="Note (optional)" value={note} onChange={(e) => setNote(e.target.value)} inputProps={{ maxLength: 500 }} />
                {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="inherit">Cancel</Button>
                <Button onClick={submit} variant="contained" color="error" disabled={!reason}>Escalate</Button>
            </DialogActions>
        </Dialog>
    );
};

export default EscalateDialog;
